﻿<div class="card text-white" [ngClass]="'bg-' + getBsClass(message.type)">
  @if (message.title) {
    <div class="card-header">
      <div class="card-title text-capitalize-first mb-0">{{message.title}}</div>
    </div>
  }
  <div class="card-body text-center text-dark bg-white">
    <div [innerHTML]="safeMessage"></div>
    @if (message.info !== undefined) {
      <div class="info">
        <span class="material-symbols-rounded icon">info</span>
        <div [innerHTML]="message.info"></div>
      </div>
    }
  </div>
  <div class="card-footer bg-white">
    <div class="btn-group d-flex" role="group">
      @for (button of message.buttons; track button; let i = $index) {
        @switch (button) {
          @case ('ok') {
            <a class="btn w-100" [ngClass]="'btn-' + getBsClass(message.type, i)" (click)="close(button)">{{'UI.Label.OK|OK' | translate}}</a>
          }
          @case ('cancel') {
            <a class="btn w-100" [ngClass]="'btn-' + getBsClass(message.type, i)" (click)="close(button)">{{'UI.Label.Cancel|Mégsem' | translate}}</a>
          }
          @case ('yes') {
            <a class="btn w-100" [ngClass]="'btn-' + getBsClass(message.type, i)" (click)="close(button)">{{'UI.Label.Yes|Igen' | translate}}</a>
          }
          @case ('no') {
            <a class="btn w-100" [ngClass]="'btn-' + getBsClass(message.type, i)" (click)="close(button)">{{'UI.Label.No|Nem' | translate}}</a>
          }
          @case ('close') {
            <a class="btn w-100" [ngClass]="'btn-' + getBsClass(message.type, i)" (click)="close(button)">{{'UI.Label.Close|Bezár' | translate}}</a>
          }
        }
      }
    </div>
  </div>
</div>
